/**
 * Frappe API Service
 * Service for fetching data from Frappe Blog doctype
 */

const API_BASE = window.location.origin;

/**
 * Get CSRF token from Frappe
 */
const getCSRFToken = () => {
  // Try to get token from frappe global object
  if (window.frappe && window.frappe.csrf_token) {
    return window.frappe.csrf_token;
  }
  
  // Fallback: try to get from cookie
  const cookies = document.cookie.split(';');
  for (let cookie of cookies) {
    const [name, value] = cookie.trim().split('=');
    if (name === 'csrf_token') {
      return decodeURIComponent(value);
    }
  }
  
  return null;
};

/**
 * Create headers with CSRF token
 */
const getHeaders = () => {
  const headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  };
  
  const csrfToken = getCSRFToken();
  if (csrfToken) {
    headers['X-Frappe-CSRF-Token'] = csrfToken;
  }
  
  return headers;
};

export const frappeApi = {
  /**
   * Fetch all published blog posts
   */
  async getBlogPosts() {
    try {
      const response = await fetch(
        `${API_BASE}/api/method/mespi_utils.api.get_published_blog_posts`,
        {
          method: 'GET',
          headers: getHeaders()
        }
      );
      
      if (!response.ok) {
        throw new Error('Failed to fetch blog posts');
      }
      
      const data = await response.json();
      return data.message || [];
    } catch (error) {
      console.error('Error fetching blog posts:', error);
      return [];
    }
  },

  /**
   * Fetch a single blog post by route or name
   */
  async getBlogPost(identifier) {
    try {
      const response = await fetch(
        `${API_BASE}/api/method/mespi_utils.api.get_blog_post?identifier=${encodeURIComponent(identifier)}`,
        {
          method: 'GET',
          headers: getHeaders()
        }
      );
      
      if (!response.ok) {
        throw new Error('Blog post not found');
      }
      
      const data = await response.json();
      return data.message || null;
    } catch (error) {
      console.error('Error fetching blog post:', error);
      return null;
    }
  },

  /**
   * Fetch blog posts by category
   */
  async getBlogPostsByCategory(category) {
    try {
      const response = await fetch(
        `${API_BASE}/api/method/mespi_utils.api.get_published_blog_posts`,
        {
          method: 'GET',
          headers: getHeaders()
        }
      );
      
      if (!response.ok) {
        throw new Error('Failed to fetch blog posts by category');
      }
      
      const data = await response.json();
      const posts = data.message || [];
      
      // Filter by category on client side
      return posts.filter(post => post.blog_category === category);
    } catch (error) {
      console.error('Error fetching blog posts by category:', error);
      return [];
    }
  }
};
